import { useSyncExternalStore } from "react";

// Consent lives only in memory: valid for the current visit, never stored in the browser.
let allowed = false;
const subs = new Set();

export const setMapConsent = (value) => {
  allowed = value;
  subs.forEach((fn) => fn());
};

const subscribe = (fn) => {
  subs.add(fn);
  return () => subs.delete(fn);
};

export const useMapConsent = () => useSyncExternalStore(subscribe, () => allowed);
